import type { FormErrors } from "@repo/shared-types";
import { ErrorMessage } from "./error";

interface GeneralErrorProps {
  errors: FormErrors;
  customRender?: Record<string, React.ReactNode>;
}

export function GeneralError({ errors, customRender }: GeneralErrorProps) {
  if (!errors._general || !errors._general.message) return null;
  let customRenderNode = null;
  if (
    errors._general.code &&
    customRender &&
    customRender[errors._general.code]
  ) {
    customRenderNode = customRender[errors._general.code];
  }
  return (
    <ErrorMessage
      message={errors._general.message}
      customRender={customRenderNode}
    />
  );
}
